<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Paramétrage des sujets</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="items" :options="options">
          <div slot="action" slot-scope="props">
            <b-button type="button" @click.prevent="destroy(props.row.id)" class="badge badge-danger mr-3 p-2"><i class="fa fa-remove"></i> Supprimer
            </b-button>
            <b-button type="button" @click="editAdminContact('edit', props.row.id)" class="badge badge-primary p-2">
              <i class="fa fa-edit"></i> Modifier
            </b-button>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button type="button"  @click="editAdminContact('add')" class="pull-right" size="md" variant="primary">
            <i class="fa fa-plus"></i> Ajouter un sujet
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "../../utils/auth"

export default {
  data() {
    return {
      columns: [
        "sujet",
        "destinataire_email",
        "action"
      ],
      items: [],
      options: {
        headings: {
          sujet: "Sujet",
          destinataire_email: "Email Destinataire",
          action: "Action"
        },
        sortable: ["sujet","destinataire_email"],
        filterable: ["sujet","destinataire_email"],
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: {
          filterPlaceholder: "Sujet, Email"
        }
      }
    };
  },
  mounted() {
    this.all();
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    all() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceBeneficiaire/admincontacts")
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          this.items = response.data.adminContacts;
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Un probléme est survenu, merci de contacter l'administrateur",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    destroy(id) {
          this.$swal.fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous vraiment supprimer ce sujet ?",
            type: 'warning',
            showCancelButton: true,
            cancelButtonColor:"#ff1744",
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Supprimer',
            }).then((result) => {
              if (!result.value) {
                this.$store.commit('IS_LOADING', true)
                this.$axios
                .post("/espaceBeneficiaire/admincontacts/delete/"+id)
                .then(response => {
                  this.$store.commit('IS_LOADING', false)
                  this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le sujet a bien été supprimé',showConfirmButton: false, timer: 5000})
                  this.all()
                })
                .catch(function(error){
                  self.$store.commit('IS_LOADING', false)
                  self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Un probléme est survenue, merci de contacter l\'administrateur',showConfirmButton: false, timer: 5000})
                })
              }
            })

    },
    editAdminContact(to,id) {
      if (to === 'edit') {
          this.$router.push({ path: '/espace-beneficiaire/gestion-des-sujets/edit/' + id })
      } else if(to === "add") {
          this.$router.push({ path: '/espace-beneficiaire/gestion-des-sujets/add' })
      }
    },
  }
};
</script>
